import React from 'react'

import { buildComponent } from '../../../../components/factory'

import * as UI from '@mantine/core'
import * as Routing from 'wouter'
import * as Icons from '../../../../components/icons'
import { useStoreState } from '../../../../hooks/state'
import { useIsClient, useAccessibleSpaces } from '../../../../hooks/use-role'

export const Title = buildComponent<{ space: string }>()
  .withLifecycle(({ props }) => {
    const space = useStoreState((store) =>
      store.space.list.find((s) => s._id === props.space),
    )
    const isClient = useIsClient()
    const accessibleSpaces = useAccessibleSpaces()

    const name = space?.name ?? '...'

    // Un client rattaché à un seul espace atterrit directement dessus : le
    // retour vers la liste n'aurait rien à montrer. Même source que la
    // redirection de l'écran Espaces, pour que les deux ne divergent pas.
    const canGoBack = !isClient || accessibleSpaces.length > 1

    return { name, isClient, canGoBack }
  })
  .withRender(({ lifecycle }) => (
    <UI.Group
      mx={-16}
      px={16}
      mt={-16}
      py={16}
      sx={{
        position: 'sticky',
        top: 72,
        zIndex: 10,
        backgroundColor: '#f8f9fc',
      }}
    >
      {lifecycle.canGoBack && (
        <Routing.Link to="/spaces">
          <UI.ActionIcon color="blue" size="xl" component="a">
            <Icons.FontAwesomeIcon size="lg" icon={Icons.Solid.faArrowLeft} />
          </UI.ActionIcon>
        </Routing.Link>
      )}
      <UI.Stack spacing={0}>
        <UI.Stack spacing={0}>
          <UI.Title>
            <UI.Text size={22}>
              Espace{' '}
              <UI.Text component="span" weight={700} color="blue.900">
                {lifecycle.name}
              </UI.Text>
            </UI.Text>
          </UI.Title>
          <UI.Text color="dimmed">
            {lifecycle.isClient ? (
              <>
                Modifiez les créneaux de réservation, les cocons et les
                maintenances de <b>{lifecycle.name}</b>.
              </>
            ) : (
              <>
                Modifiez les informations, le forfait et les cocons de{' '}
                <b>{lifecycle.name}</b>.
              </>
            )}
          </UI.Text>
        </UI.Stack>
      </UI.Stack>
    </UI.Group>
  ))
